// некритические стили
import './app.scss';

// форма поиска
import { searchFormInit } from './components/search-form/index';
// блок прямого эфира
import LiveFeed from './components/live/live-feed';
// Обновление времени
import { liveInit } from './components/live/init';
// real time messages
import './services/real-time/subscribe';
// ленивая загрузка изображений
import lazyload from './services/lazyload';
// автоматический ресайз поля ввода
import TextareaResizer from './services/textarea-resize';
// блок подписок на теги
import { initMyProglib } from './components/my-proglib';
// фильтр по тегам в фиде
import * as tagsFilter from './components/tags-filter';
// уведомления в шапке
import { loadNotifications } from './components/notifications/index';
import { initSidebar } from './services/sidebar';
import { initListener } from './services/live';
// Сценарный диалог с пользователем
import { ScenarioDialog } from './components/scenario-dialog/index';
// Нативный рекламный блок с сообщением
import { WindowMessage } from './components/ads-window/index';
import { showAnnouncement } from './components/notify-toast/index';
import { init as initImg } from './services/picture-fallback';
// Аналитика
import { click as analyzeClick } from "./services/analytics.js";
// Селект
import { init as initSelect } from './components/uic-select/index';
// Селект
import { init as initInput } from './components/uic-input/index';
// Баннер
import { init as initImageInput } from './components/image-input/index';
import Banner from './components/banner';
import { isTrustedActionEvent, openTrustedUrl } from './services/helpers/slot-codec';
import { initPromoCards } from './services/helpers/slot-shadow';
import { handleAll as handleTgInputs } from './services/input-handlers/tg-username-input';
import { handleAll as handlePhoneInputs } from './services/input-handlers/phone-number-input';
import { initCustomLeads } from './services/custom-lead';
// @TEMP start
// import { useCourseBrand } from './misc/course-branding';
import useImageBanner from './misc/image-banner';
// @TEMP end

// инициализация
onDomReady.then(() => {
  searchFormInit();
  LiveFeed.init();
  liveInit();

  lazyload();
  TextareaResizer.init();
  initMyProglib();
  tagsFilter.init();
  WindowMessage.init();

  // @TEMP start
  // useCourseBrand();
  useImageBanner();
  // @TEMP end

  window.tagsFilter = tagsFilter;
  window.loadNotifications = loadNotifications;
  window.ScenarioDialog = ScenarioDialog;
  window.showAnnouncement = showAnnouncement;

  initSidebar();
  initListener();

  function toggleImages(isDark)
  {
    document.querySelectorAll("[data-dark-src]")
    .forEach(img => img.src = isDark ? img.dataset.darkSrc : img.dataset.lightSrc);
  }

  handleTgInputs();
  handlePhoneInputs();

  document.querySelectorAll("picture img")
  .forEach(initImg);

  document.addEventListener("theme.toggled", e => toggleImages(e.detail.enabled));

  document.querySelectorAll("[data-dark-src]")
  .forEach(img => img.dataset.lightSrc = img.src);

  document.querySelectorAll("[data-uic=select]")
  .forEach(select => initSelect(select));

  document.querySelectorAll("[data-uic=input]")
  .forEach(input => initInput(input));

  document.querySelectorAll("[data-image-input]")
  .forEach(input => initImageInput(input));

  document.querySelectorAll("[data-p-slot], [data-config-item]")
  .forEach(banner => new Banner(banner));

  initPromoCards(document);
  initCustomLeads();

  toggleImages(document.documentElement.classList.contains("dark"));

  document.addEventListener('click', e => {
    let spoilerToggler = e.target.closest('.spoiler__visible');
    
    if (spoilerToggler) {
      let spoiler = spoilerToggler.closest('.spoiler');
      if (spoiler) spoiler.classList.toggle('opened');
    }

    const cookedElement = e.target.closest("[data-click-cookie]");

    if (cookedElement && e.isTrusted)
    {
      const cookie = cookedElement.dataset.clickCookie;
      const maxAge = 60 * 60 * 24 * 30;

      document.cookie = `${cookie}=${cookie}; path=/; max-age=${maxAge}`;
    }

    const promoCard = e.target.closest("[data-p-promo]");
    if (promoCard && !e.target.closest("[data-p-close], [data-close-btn]"))
    {
      if (!e.isTrusted) {
        e.preventDefault();
        return;
      }
      const link = promoCard.dataset.pLink;
      if (link) {
        openTrustedUrl(e, link);
      }
    }

    const analyticsButton = e.target.closest("[data-analytics-btn]");

    if (analyticsButton)
    {
      analyzeClick(analyticsButton);
    }
  });

  const handleCloseAction = e => {
    const closeBtn = e.target.closest("[data-p-close], [data-close-btn]");
    const closeSelector = closeBtn ? (closeBtn.dataset.pClose || closeBtn.dataset.closeBtn) : "";

    if (closeBtn && closeSelector)
    {
      if (!isTrustedActionEvent(e)) {
        return;
      }
      const target = e.target.closest(closeSelector);

      if (target)
      {
        e.preventDefault();
        e.stopPropagation();
        target.style.display = "none";
      }
    }
  };

  document.addEventListener('click', handleCloseAction, true);
  document.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleCloseAction(e);
    }
  }, true);

  document.addEventListener('keydown', e => {
    if (e.key !== 'Enter' && e.key !== ' ') {
      return;
    }
    const promoCard = e.target.closest("[data-p-promo]");
    if (promoCard && !e.target.closest("[data-p-close], [data-close-btn]"))
    {
      if (!isTrustedActionEvent(e)) {
        e.preventDefault();
        return;
      }
      const link = promoCard.dataset.pLink;
      if (link) {
        openTrustedUrl(e, link);
      }
    }
  });
});

// дополнительные обработчики
document.body.addEventListener('feed.events.update', () => lazyload());
document.body.addEventListener('update.lazy', () => lazyload());

// действия с сущностями
import './services/actions/delete'; // удаление сущности
import './services/actions/moderation'; // отзыв с модерации
import './services/actions/reactions'; // лайки, комменты

// прокрутка блока тегов, табов
import { reset as resetDragscroll } from 'dragscroll';

import './app.jsx';

document.body.addEventListener('update.lazy', () => resetDragscroll());
